import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

export interface SearchHighlightOptions {
    searchQuery?: string;
}

// Global state to store search query
let globalSearchQuery: string = '';

export const setSearchQuery = (query: string) => {
    globalSearchQuery = query || '';
};

export const clearSearchQuery = () => {
    globalSearchQuery = '';
};

const SearchHighlightPluginKey = new PluginKey('searchHighlight');

export const SearchHighlight = Extension.create<SearchHighlightOptions>({
    name: 'searchHighlight',

    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: SearchHighlightPluginKey,
                state: {
                    init() {
                        return DecorationSet.empty;
                    },
                    apply(tr, oldState) {
                        const query = globalSearchQuery.trim().toLowerCase();
                        
                        // Check if this is a forced update (when search query changes but doc doesn't)
                        const isForcedUpdate = tr.getMeta('searchHighlightUpdate');
                        
                        if (!query) {
                            return DecorationSet.empty;
                        }

                        const decorations: Decoration[] = [];
                        const doc = tr.doc;

                        // Find all text nodes and search for the query
                        doc.descendants((node: any, pos: number) => {
                            if (node.isText && node.text) {
                                const text = node.text;
                                const textLower = text.toLowerCase();
                                let searchIndex = 0;

                                while ((searchIndex = textLower.indexOf(query, searchIndex)) !== -1) {
                                    const from = pos + searchIndex;
                                    const to = pos + searchIndex + query.length;

                                    // Validate positions
                                    if (from >= 0 && to <= doc.content.size && from < to) {
                                        decorations.push(
                                            Decoration.inline(from, to, {
                                                class: 'tiptap-search-highlight',
                                            })
                                        );
                                    }

                                    searchIndex += query.length;
                                }
                            }
                        });

                        // If document changed, always create new decorations
                        // If forced update, also create new decorations
                        return DecorationSet.create(doc, decorations);
                    },
                },
                props: {
                    decorations(state) {
                        const pluginState = SearchHighlightPluginKey.getState(state);
                        return pluginState || DecorationSet.empty;
                    },
                },
            }),
        ];
    },
});

